<template>

    <div v-if="button.status !== 'hide'" class="w-full learnworlds-button learnworlds-button-solid-brand learnworlds-button-normal learnworlds-element" :class="buttonClasses" @click="enrollButtonClicked">
        <!-- Enroll Button -->
        <span v-if="button.status === 'showcase-button'">{{ $t('course.enroll') }}</span>
        <span v-else-if="button.status === 'continue'">{{ $t('course.continue') }}</span>
        <span v-else-if="button.status === 'subscribe'">{{ $t('subscriptions.buy') }}</span>
        <span v-else-if="button.status === 'multiple' && course.status === 'paid'">{{ $t('course.enroll') }}</span>
        <span v-else-if="button.status === 'enroll' && course.status === 'free'">{{ $t('course.free_register') }}</span>
        <div v-else-if="button.status === 'enroll' && course.status === 'paid'" class="flex a-i-c">
            <span class="mr-5">{{ $t('course.enroll') }}</span>
            <span v-if="course.discountFlag" class="flex a-i-c">
                <span class="lw-deleted-price">{{ course.currency }}{{ course.price }}</span>
                <strong>{{ course.currency }}{{ course.discountPrice }}</strong>
            </span>
            <span v-else>
                <strong>{{ course.currency }}{{ course.price }}</strong>
            </span>
        </div>
        
        <!-- Options of multiple button -->
        <div v-if="(button.status === 'multiple' && course.status === 'paid')" class="-course-enrollment-dropdown lw-body-bg learnworlds-align-left">
            <div class="learnworlds-element lw-bb-1px-fadeout80 lw-padding-small">
                <div class="learnworlds-overline-text no-margin-bottom learnworlds-element">{{ $t('common.pay_once') }}</div>
                <div class="lw-body-bg">
                    <div class="lw-cols one-row one-row-tl one-row-tp one-row-sl one-row-sp align-items-center justify-content-space-between">
                        <div class="col no-padding span_7_of_12 span_7_of_12-tl span_7_of_12-tp span_7_of_12-sl span_7_of_12-sp">
                            <div v-if="course.discountFlag" class="learnworlds-main-text learnworlds-main-text-normal no-margin-bottom">
                                <span class="lw-deleted-price v-middle">{{course.currency}}{{course.price}}</span>
                                <strong class="v-middle">{{course.currency}}{{course.discountPrice}}</strong>
                            </div>
                            <div v-else class="learnworlds-main-text learnworlds-main-text-normal no-margin-bottom">
                                <strong>{{course.currency}}{{course.price}}</strong>
                            </div>
                        </div>
                        <div class="col no-padding learnworlds-align-right span_5_of_12 span_5_of_12-tl span_5_of_12-tp span_5_of_12-sl span_5_of_12-sp">
                            <button class="learnworlds-button learnworlds-button-small pl-30 pr-30 no-edit learnworlds-button-solid-brand"
                            @click="purchaseOptionClickedBuy('course', course.titleId, ...arguments)">
                                {{ $t('course.enroll') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Payment plans for multiple button -->
            <div v-if="activePaymentPlans.length" class="learnworlds-element lw-bb-1px-fadeout80 lw-padding-small">
                <div class="learnworlds-overline-text no-margin-bottom learnworlds-element">{{ $t('common.payment_plans') }}</div>
                <div v-for="plan in activePaymentPlans" class="lw-body-bg learnworlds-element mb-1rem">
                    <div class="lw-cols one-row one-row-tl one-row-tp one-row-sl one-row-sp align-items-center justify-content-space-between">
                        <div class="col no-padding span_7_of_12 span_7_of_12-tl span_7_of_12-tp span_7_of_12-sl span_7_of_12-sp">
                            <div class="learnworlds-main-text learnworlds-main-text-normal no-margin-bottom" v-if="plan.nameOverride">{{ plan.name }}</div>

                            <div v-else-if="plan.type === 'without_upfront'" class="learnworlds-main-text learnworlds-main-text-normal no-margin-bottom">
                                <strong>{{ plan.paymentsCount }}</strong> {{ $t('common.payments_of') }}
                                <strong>{{ plan.currency}}{{ plan.amount}}/{{ plan.subscriptionIntervalType }}</strong>
                            </div>

                            <div v-else class="learnworlds-main-text learnworlds-main-text-normal no-margin-bottom">
                                <strong>{{ plan.currency }}{{ plan.firstAmount }}</strong> 
                                <span>{{ $t('common.upfront') }}</span> 
                                <span>{{ $t('common.and') }}</span> 
                                <strong>{{ plan.paymentsCount }}</strong> {{ $t('common.payments_of') }} 
                                <strong>{{ plan.currency }}{{ plan.amount }}/{{ plan.subscriptionIntervalType }}</strong>
                            </div>

                        </div>
                        <div class="col no-padding learnworlds-align-right span_5_of_12 span_5_of_12-tl span_5_of_12-tp span_5_of_12-sl span_5_of_12-sp">
                            <button :href="plan.url" class="learnworlds-button learnworlds-button-small pl-30 pr-30 no-edit learnworlds-button-solid-brand"
                            @click="paymentPlanClicked(plan.url, ...arguments)">
                                {{ $t('common.enroll') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Bundles for multiple button -->
            <div v-if="activeBundles.length" class="learnworlds-element lw-bb-1px-fadeout80 lw-padding-small">
                <div class="learnworlds-overline-text no-margin-bottom learnworlds-element">{{ $t('common.bundles') }}</div>
                <div v-for="bundle in activeBundles" class="lw-body-bg learnworlds-element mb-1rem">
                    <div class="lw-cols one-row one-row-tl one-row-tp one-row-sl one-row-sp align-items-center justify-content-space-between">
                        <div class="col no-padding span_7_of_12 span_7_of_12-tl span_7_of_12-tp span_7_of_12-sl span_7_of_12-sp">
                            <div class="learnworlds-main-text learnworlds-main-text-normal no-margin-bottom">
                                {{ bundle.title }} (
                                <a
                                    :href="'/bundles?bundle_id=' + bundle.titleId"
                                    @click="purchaseOptionClickedView('bundle', bundle.titleId , ...arguments)"
                                    target="_blank">
                                    {{ bundle.courses.length }} {{ $t('common.courses') }}
                                </a>
                                )
                            </div>
                            <div class="learnworlds-main-text no-margin-bottom learnworlds-main-text-normal">
                                <span class="lw-deleted-price v-middle">{{ bundle.currency }}{{ bundle.price }}</span>
                                <strong class="v-middle">{{ bundle.currency }}{{ bundle.discount_price }}</strong>
                            </div>
                        </div>
                        <div class="col no-padding learnworlds-align-right span_5_of_12 span_5_of_12-tl span_5_of_12-tp span_5_of_12-sl span_5_of_12-sp">
                            <button class="learnworlds-button learnworlds-button-small pl-30 pr-30 no-edit learnworlds-button-solid-brand"
                            :href="'/payment?product_id=' + bundle.titleId + '&type=bundle'"
                            @click="purchaseOptionClickedBuy('bundle', bundle.titleId , ...arguments)">
                                {{ $t('course.enroll') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Subscriptions for multiple button -->
            <div v-if="activeSubscriptions.length" class="learnworlds-element lw-padding-small">
                <div class="learnworlds-overline-text no-margin-bottom learnworlds-element">{{ $t('common.subscription') }}</div>
                <div v-for="subscription in activeSubscriptions" class="lw-body-bg learnworlds-element mb-1rem">
                    <div class="lw-cols one-row one-row-tl one-row-tp one-row-sl one-row-sp align-items-center justify-content-space-between">
                        <div class="col no-padding span_7_of_12 span_7_of_12-tl span_7_of_12-tp span_7_of_12-sl span_7_of_12-sp">
                            <div class="learnworlds-main-text no-margin-bottom learnworlds-main-text-normal">
                                {{ subscription.title }} (
                                <a
                                    :href="'/subscriptions?id=' + subscription.titleId"
                                    @click="purchaseOptionClickedView('subscription', subscription.titleId , ...arguments)"
                                    target="_blank">{{ subscription.courses.length }} {{ $t('common.courses') }}
                                </a>
                                )
                            </div>
                            <div class="learnworlds-main-text no-margin-bottom learnworlds-main-text-normal">
                                <strong>{{ subscription.currency }}{{ subscription.price }}/<span v-if="subscription.interval > 1">{{ subscription.interval }}</span>{{ subscription.interval_type }}</strong>
                            </div>
                        </div>
                        <div class="col no-padding learnworlds-align-right span_5_of_12 span_5_of_12-tl span_5_of_12-tp span_5_of_12-sl span_5_of_12-sp">
                            <button :href="'/payment?product_id=' + subscription.titleId + '&type=subscription'"
                            class="learnworlds-button learnworlds-button-small pl-30 pr-30 no-edit learnworlds-button-solid-brand"
                            @click="purchaseOptionClickedBuy('subscription', subscription.titleId , ...arguments)">
                                {{ $t('course.enroll') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Subscriptions for not multiple button -->
        <div v-else-if="(button.status === 'subscribe' && course.status === 'paid' && activeSubscriptions.length)" class="-course-enrollment-dropdown p-1rem-1rem-0-1rem lw-body-bg learnworlds-align-left">
            <button v-for="subscription in activeSubscriptions" class="w-full learnworlds-button learnworlds-button-normal learnworlds-button-solid-brand mb-1rem"
               @click="purchaseOptionClickedView('subscription', subscription.titleId , ...arguments)"
               :href="'/subscriptions?id=' + subscription.titleId">
                    
                <div class="learnworlds-main-text learnworlds-main-text-normal no-margin-bottom">{{ subscription.title }}</div>&nbsp;
                <div class="learnworlds-main-text learnworlds-main-text-normal no-margin-bottom">
                    <strong>{{ subscription.currency }}{{ subscription.price }}/<span v-if="subscription.interval > 1">{{ subscription.interval }}</span>{{ subscription.interval_type }}</strong>
                </div>
            
            </button>
        </div>
        <div class="specific-editing-lbl" style="user-select: none;" v-if="showTooltip">
            Automatic system button
        </div>
    </div>
    
</template>

<script>
    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";

    export default {
        name: "CourseEnrollLayout1",
        props: {
            course: {
                type: Object
            },
            button: {
                type: Object
            },
            showTooltip: {
                type: Boolean
            }
        },
        mixins: [
            ComponentTemplatesMixin
        ],
        computed: {
            activePaymentPlans () {
                return this.course && this.course.hasPaymentPlans ? this.course.paymentPlans : [];
            },
            activeBundles () {
                return this.course && this.course.hasBundles ? this.course.bundles.filter(bundle => bundle.access === 'public') : [];
            },
            activeSubscriptions () {
                return this.course && this.course.hasSubscriptions ? this.course.subscriptions : [];
            },
            buttonClasses () {
                const buttonClasses = [];
                if (
                    this.button.status === 'multiple' ||
                    (this.button.status === 'subscribe' && this.course.status === 'paid' && this.activeSubscriptions.length) // this happens when school is in subscriptions only mode
                ) {
                    buttonClasses.push('with-dropdown');
                }
                if (this.showTooltip) {
                    buttonClasses.push('with-tooltip');
                }

                return buttonClasses;
            }
        },
        methods: {
            paymentPlanClicked (planURL, event) {
                event.preventDefault();
                this.emitAction('payment-plan-clicked', planURL);
            },
            purchaseOptionClickedView (productType, productId, event) {
                event.preventDefault();
                this.emitAction('purchase-option-clicked-view', {productType, productId});
            },
            purchaseOptionClickedBuy (productType, productId, event) {
                event.preventDefault();
                this.emitAction('purchase-option-clicked-buy', {productType, productId});
            },
            enrollButtonClicked (event) {
                event.preventDefault();
                this.emitAction('enroll-button-clicked');
            }
        }
    }
</script>
